export enum ActionType {
  RESTART_SOLUTION = 'R',
  START_SOLUTION = 'H',
  INTERRUPT_SOLUTION = 'I'
}

export enum ChangeType {
  CONFERENCE_MEDICATION = 58,
  CONFERENCE_SOLUTION = 54,
  ADJUST_SPEED = 5,
  START = 1,
  RESTART = 3,
  INTERRUPT = 2
}

export enum InfusionScreenType {
  ADMIN_BY_SCHEDULE,
  FIRST_CHECK,
  RESTART_SOLUTION,
  START_SOLUTION
}

export enum OptionCheck {
  FIRST_CHECK = 'MPC',
  SAME_USER = 'MMU'
}

export enum AdminType {
  GRAMA = 'g',
  INFUSION_SPEED = 'V',
  MILIGRAMAS = 'mg',
  MILILITROS = 'ml',
  MILILITROS_PER_HOUR = 'mlh',
  OPEN = 'A',
  PROCESS = 'P',
  PROCESS_OR_SCHEDULE = 'PH',
  SCHEDULE = 'H',
  TIME = 'T'
}

export enum InfusionHourStatus {
  ADMINISTERED  = 'ADMINISTERED',
  CHECKED       = 'CHECKED',
  CHECKED_FIRST = 'CHECKED_FIRST',
  INTERRUPTED   = 'INTERRUPTED',
  PENDING       = 'PENDING',
  PREPARATION   = 'PREPARATION',
  STARTED       = 'STARTED'
}

export enum InfusionItemStatus {

  II          = 'II',
  INTERRUPTED = 'INT',
  NOT_STARTED = 'N',
  RESTARTED   = 'R',
  STARTED     = 'I',
  T           = 'T',
  SUSPEND     = 'S'
}
